// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"e82a8aff","341":"85e66e3c","621":"d5b76cf4","647":"e18ea4f9","811":"478bb558"}[chunkId] + ".chunk.js";
};